import { render, staticRenderFns } from "./Parties.vue?vue&type=template&id=5666c07e&scoped=true&"
import script from "./Parties.vue?vue&type=script&lang=js&"
export * from "./Parties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5666c07e",
  null
  
)

export default component.exports